import { Component } from '@angular/core';

import { BaseComponent } from '../_base.component';

/**
 * @ignore
 */
@Component({
  selector: 'uex-input-checkbox',
  templateUrl: './checkbox.component.html',
  host: {
    class: 'uex-input-checkbox'
  }
})
export class InputCheckboxComponent extends BaseComponent<boolean> {
  public toggleValue() {
    this.schema.setValue(!this.value);
  }
}
